export enum SetLootsActionTypes {
  UPDATING_LOOTS = 'set-loots/UPDATING_LOOTS',
  LOOTS_UPDATED = 'set-loots/LOOTS_UPDATED',
}
